const istate = {
  categories: [],
};

const categoriesReducer = (state = istate, action) => {
  switch (action.type) {
    case "ADD_CATEGORY": {
      state = {
        ...state,
        categories: [...state.categories, action.payload],
      };
      return state;
    }
    case "SET_CATEGORIES": {
      state = {
        ...state,
        categories: action.payload,
      };
      return state;
    }
    default:
      return state;
  }
};

export default categoriesReducer;
